import React from "react";

// Props for the Layout component
interface LayoutProps {
  children: React.ReactNode; // Nested components (e.g., InputGroup, WarningMessage, FindRoutesButton)
  map: React.ReactNode; // MapContainer component
  routes: React.ReactNode; // RouteCard component
}

// Component to render the top-level UI structure of the transit planner
const Layout: React.FC<LayoutProps> = ({ children, map, routes }) => {
  const version = window.trpSettings?.version;

  return (
    <div className="transit-planner-container">
      <div className="panel-map-wrapper">
        <div className="panel-box">
          <div className="panel">
            <h2 className="panel-title">
              Plan Your Trip
              {version && <span className="version-badge">v{version}</span>}
            </h2>
            {children}
          </div>
        </div>
        {map}
      </div>
      {routes}
    </div>
  );
};

export default Layout;
